/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdateReceiptPositionDto
 */
export interface CreateUpdateReceiptPositionDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateReceiptPositionDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateReceiptPositionDto
     */
    amount?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateReceiptPositionDto
     */
    vat: CreateUpdateReceiptPositionDtoVatEnum;
    /**
     * 
     * @type {number}
     * @memberof CreateUpdateReceiptPositionDto
     */
    order?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateUpdateReceiptPositionDto
     */
    quantity?: number | null;
}


/**
 * @export
 */
export const CreateUpdateReceiptPositionDtoVatEnum = {
    _23: '23%',
    _8: '8%',
    _5: '5%',
    _0_KR: '0% KR',
    zw: 'zw.'
} as const;
export type CreateUpdateReceiptPositionDtoVatEnum = typeof CreateUpdateReceiptPositionDtoVatEnum[keyof typeof CreateUpdateReceiptPositionDtoVatEnum];


/**
 * Check if a given object implements the CreateUpdateReceiptPositionDto interface.
 */
export function instanceOfCreateUpdateReceiptPositionDto(value: object): value is CreateUpdateReceiptPositionDto {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('vat' in value) || value['vat'] === undefined) return false;
    return true;
}

export function CreateUpdateReceiptPositionDtoFromJSON(json: any): CreateUpdateReceiptPositionDto {
    return CreateUpdateReceiptPositionDtoFromJSONTyped(json, false);
}

export function CreateUpdateReceiptPositionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateReceiptPositionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'vat': json['vat'],
        'order': json['order'] == null ? undefined : json['order'],
        'quantity': json['quantity'] == null ? undefined : json['quantity'],
    };
}

export function CreateUpdateReceiptPositionDtoToJSON(value?: CreateUpdateReceiptPositionDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'amount': value['amount'],
        'vat': value['vat'],
        'order': value['order'],
        'quantity': value['quantity'],
    };
}

